import { encryptAES, formatarComoDecimal, formatarComoMoeda, formatarMoeda2, formatDateColumn, parseLocaleNumber } from "../../contents/VariaveisGlobais";
import PedidoCompraPDF from "../../pages/Compras/PedidoCompraPDF";
import { handleSituacaoFila } from "./Aprovacao";
import { BlackFont, CelBreak, NormalFont } from "./styles"
import $ from "jquery";

import PedidoItens from "../../../lib/json/consultas/PedidoItens.json"
import TrackerNotaFiscal from "../../../lib/json/consultas/TrackerNotaFiscal.json"
import FilaAprovacao from "../../../lib/json/consultas/FilaAprovacao.json"
import ResponsiveDataTable from "../DataTable";
import ConsultaTotvs from "../../../backend/ConsultaTotvs";
import { handleValorTotal } from "./Preco";
import InputGeral from "../InputGeral/Index";
import MapaCotacaoFornecedor from "../../pages/Compras/MapaCotacao";
import FichaSolicitacaoCompra from "../../pages/Compras/FichaSolicitacaoCompra";
import { handlePrioridadeSCColumn } from "./Solicitacao";

function handleNumeroItemPCColumn(item){
    const {C7_NUM, C7_ITEM} = item.row.original

    return ( 
           <p>
                <strong>PC: </strong> {C7_NUM}
                <br/><strong>Item: </strong>{C7_ITEM}
            </p>
    )
}

function handleCCPCColumn(item){
    const {C7_CC, CTT_DESC01} = item.row.original

    return ( <CelBreak><strong>{C7_CC.trim()}</strong> - {CTT_DESC01.trim()}</CelBreak> )
}

function handleProdutoPCColumn(item){
    const {DESCRI, C7_COMPRA, Y1_NOME, C7_CC, CTT_DESC01} = item.row.original

    return ( <CelBreak>
                <strong>{item.value.trim()}</strong> - {DESCRI.trim()}
                <p>
                    <strong>Comp.: </strong> {C7_COMPRA.trim()} - {Y1_NOME.trim()}
                    <br/><strong>CC: </strong>{C7_CC.trim()} - {CTT_DESC01.trim()}
                </p>
                
            </CelBreak> )
}

function handleChangePC(dataPedidoCompra, index, value, field){
    const itemMap = dataPedidoCompra[index]
    let saldo = parseFloat(itemMap.C7_QUANT) - parseFloat(itemMap.C7_QUJE) - parseFloat(itemMap.C7_QTDACLA) - parseFloat(itemMap.C7_QUJB)
    let qtde = 0
    let total = 0
    
    switch (field) {
        case "QUANTIDADE":
            dataPedidoCompra[index].QTDSEL = formatarMoeda2(value,4);
            if (saldo < parseLocaleNumber(value)){
                dataPedidoCompra[index].QTDSEL = formatarMoeda2(saldo,4);
            } 
            break;
        case 'DESCONTO':
            dataPedidoCompra[index].DESCSEL = formatarMoeda2(value,2);
            break    
        case 'TOTAL':
            qtde = parseFloat( (Number(parseLocaleNumber(value) ) / Number(parseFloat(itemMap.C7_PRECO)) ).toFixed(4) )
    
            if (saldo >= qtde){
                dataPedidoCompra[index].QTDSEL = formatarMoeda2(qtde,4);
                dataPedidoCompra[index].TOTAL = formatarMoeda2(value,2)
            }
            break    
        default:
            break;
    }
    
    if (field != 'TOTAL'){
        total = parseFloat( ( ( Number(parseLocaleNumber(itemMap.QTDSEL)) * Number(parseFloat(itemMap.C7_PRECO)) ) ).toFixed(2) )
        dataPedidoCompra[index].TOTAL = formatarMoeda2(total,2)

        total = parseFloat( ( ( Number(parseLocaleNumber(itemMap.QTDSEL)) * Number(parseFloat(itemMap.C7_PRECO)) ) - Number( parseLocaleNumber(itemMap.DESCSEL) ) ).toFixed(2) )
        dataPedidoCompra[index].TOTALDESC = formatarMoeda2(total,2)
    }

    $(`#QTD_${itemMap.C7_NUM}_${itemMap.C7_ITEM}`)[0].value = dataPedidoCompra[index].QTDSEL
    $(`#DESC_${itemMap.C7_NUM}_${itemMap.C7_ITEM}`)[0].value = dataPedidoCompra[index].DESCSEL
    $(`#TOTAL_${itemMap.C7_NUM}_${itemMap.C7_ITEM}`)[0].value = dataPedidoCompra[index].TOTAL
    $(`#TTDSC_${itemMap.C7_NUM}_${itemMap.C7_ITEM}`)[0].innerHTML = 'Total: ' + formatarComoMoeda(dataPedidoCompra[index].TOTALDESC,2)
}

function handleSaldoPrecoPC(item, dataPedidoCompra){
    const { C7_PRECO, C7_TOTAL, C7_QUANT, C7_QUJE, C7_QTDACLA, C7_QUJB} = item.row.original
    const unitario = formatarComoMoeda(C7_PRECO, 4)
    const total = formatarMoeda2(parseFloat(C7_TOTAL),2)
    const saldoAux = parseFloat(C7_QUANT) - parseFloat(C7_QUJE) - parseFloat(C7_QTDACLA) - parseFloat(C7_QUJB)
	const saldo = formatarMoeda2(saldoAux,4);

    return ( <>
        <strong>Qtd. Saldo: </strong>{saldo}
        <br/><strong>Unitário: </strong>{unitario}
        <br/><strong>Total: </strong>{total}
    </>)
}

function handleSaldoPCColumn(item, dataPedidoCompra){
    const {C7_NUM, C7_ITEM, C7_PRECO, C7_TOTAL, C7_QUANT, C7_QUJE, C7_QTDACLA, C7_QUJB} = item.row.original
    const index = item.cell.row.index
    const unitario = formatarComoMoeda(C7_PRECO, 4)
    const qtdUso = parseFloat(C7_QUJE) + parseFloat(C7_QTDACLA) + parseFloat(C7_QUJB)
    const saldoAux = parseFloat(C7_QUANT) - qtdUso
    const totalAux = (qtdUso > 0 ? Number(saldoAux) * Number(parseFloat(C7_PRECO)) : Number(parseFloat(C7_TOTAL)))
    const total = formatarMoeda2(parseFloat(totalAux), 2)
	const saldo = formatarMoeda2(saldoAux,4);

    dataPedidoCompra[index].QTDSEL = saldo;
    dataPedidoCompra[index].TOTAL = total;
    dataPedidoCompra[index].TOTALDESC = total;
    return ( <>
        <strong>Qtd.: </strong>
        <InputGeral 
            idComponente={`QTD_${C7_NUM}_${C7_ITEM}`}
            tipo="monetario"
            decimal={4}            
            onChange={(e, value) => { handleChangePC(dataPedidoCompra, index, value, "QUANTIDADE") }}
            placeholder="Quantidade"
            valueNoUpdate={saldo}            
        />
        <strong>Desconto: </strong>
        <InputGeral 
            idComponente={`DESC_${C7_NUM}_${C7_ITEM}`}
            tipo="monetario"
            decimal={2}            
            onChange={(e, value) => { handleChangePC(dataPedidoCompra, index, value, "DESCONTO") }}
            placeholder="DESCONTO"
            valueNoUpdate={formatarMoeda2('0',2)}            
        />        
        <br/><strong>Valor Total: </strong>
        <InputGeral 
            idComponente={`TOTAL_${C7_NUM}_${C7_ITEM}`}
            tipo="monetario"
            decimal={2}            
            onChange={(e, value) => { handleChangePC(dataPedidoCompra, index, value, "TOTAL") }}
            placeholder="TOTAL"
            valueNoUpdate={total}            
        />
        <br/><strong id={`TTDSC_${C7_NUM}_${C7_ITEM}`}>Total: {formatarComoMoeda(parseFloat(totalAux), 2)} </strong>
    </> )
}

function handleQtdValorPCColumn(item){
    const unitario = formatarComoMoeda(item.row.original.C7_PRECO, 4)
    const total = formatarComoMoeda(item.row.original.C7_TOTAL)

    return ( <>
        <strong>Qtd.: </strong>{item.value}
        <br/><strong>Unitário: </strong>{unitario}
        <br/><strong>Total: {total} </strong>
    </> )
}

const handleFilaAprovadores = async(Tipo, Numero, Empresa, Filial, DisparaBootBox, FechaBootBox) => {
    let columnsFilaAprovacao = [
        { Header: 'Nivel', accessor: 'CR_NIVEL' },
        { Header: 'Aprovador', accessor: 'AK_NOME' },
        { Header: 'Situação', accessor: 'CR_STATUS', Cell: handleSituacaoFila },
        { Header: 'Data Aprovação', accessor: 'CR_DATALIB', Cell: formatDateColumn },
        { Header: 'Aprovado por', accessor: 'APROVADOR' },
        { Header: 'Observação', accessor: 'CR_OBS' },
    ];

    let consultaDefault = FilaAprovacao.consulta.replace("FILTRO", ` AND CR_TIPO IN ('${Tipo}') AND CR_NUM = '${Numero}' `) + " ORDER BY CR_NIVEL ";
    
    if (Tipo == "BM','BC','BD"){
        // consultaDefault = consultaDefault.replace('AND CR_FILIAL = FILIAL(SCR)', '')
        consultaDefault = consultaDefault.replace('AND CR_NUM = ', 'AND LEFT(CR_NUM,6) = ')
    }
    let tabelasDefault = FilaAprovacao.tabelas;

    let retConsulta = await ConsultaTotvs(consultaDefault, tabelasDefault, Empresa + Filial);
    let aDataFilaAprovacao = retConsulta.data;

    const Mensagem = (
        <ResponsiveDataTable columns={columnsFilaAprovacao} data={aDataFilaAprovacao} buttons={[]} habilitaBuscar={false} />
    );

    DisparaBootBox('Fila de Aprovação - ' + Numero, Mensagem, [{ variant: 'light', action: FechaBootBox, label: '↩ Voltar' }], {}, null, 'xl');
}

const handleAbrirMapa = (Empresa, Filial, Numero, DisparaBootBox, FechaBootBox) => {
    const secretKey = window._env_?.REACT_APP_KEY_COTACAO
    const dadosCotacao = JSON.stringify({
        Filial: `${Empresa+''+Filial}`,
        Numero: Numero,
        Homologado: true
    });

    const encryptedText = encryptAES(dadosCotacao, secretKey);

    // Renderiza o componente diretamente no BootBox
    DisparaBootBox(
        `Mapa Comparativo - Nº ${Numero}`,
        () => <MapaCotacaoFornecedor encryptedText={encryptedText} />,
        [{ variant: 'light', action: FechaBootBox, label: '↩ Fechar' }],
        null,
        false,
        'xl',
        true,
        true // withComponent = true
    );

    // navigate(`../compras/Cotacoes/Mapa/Comparativo/${encryptedText}`)
}

const handleAbrirSC = (Empresa, Filial, Numero, DisparaBootBox, FechaBootBox) => {
    // Renderiza o componente diretamente no BootBox
    DisparaBootBox(
        `Solicitação de Compras - Nº ${Numero}`,
        () => <FichaSolicitacaoCompra idSolicitacaoCompras={Numero}
            itemSolicitacaoCompras="0000"
            empresaFilialCompras={Empresa+''+Filial}/>,
        [{ variant: 'light', action: FechaBootBox, label: '↩ Fechar' }],
        null,
        false,
        'xl',
        true,
        true // withComponent = true
    );
    
    // navigate(`../compras/Solicitacoes/Visualizar/${Numero}/0000/$`)
}

function handleNumeroPCColumn(item, DisparaBootBox, FechaBootBox, navigate) {
    const { C7_NUMCOT, C7_NUMSC, C7_NUM, C7_TIPO, EMPRESA, C7_FILIAL, C7_CONAPRO, C7_QUJE, C7_QTDACLA, C7_RESIDUO } = item.row.original;
    const aprov = C7_CONAPRO.trim();
    const quje = Number(C7_QUJE.trim());
    const qacl = Number(C7_QTDACLA.trim());
    const residuo = C7_RESIDUO.trim();
    const isPendente = (aprov === 'L' && quje === 0 && qacl === 0 && residuo === '');
    const tooltipValue = isPendente ? "Imprimir PDF" : "Nº Pedido";
    
    return ( <>
                {<NormalFont tooltipText={"Fila de Aprovadores"} onClick={(e)=> handleFilaAprovadores("PC','IP','AE", C7_NUM, EMPRESA, C7_FILIAL, DisparaBootBox, FechaBootBox)}><strong>Fil.: </strong>{item.value}</NormalFont>}
                <br/>{<NormalFont tooltipText={tooltipValue} onClick={()=> { if (isPendente) { handleAbrirPDF(C7_NUM, EMPRESA, C7_FILIAL) } } }><strong>PC: </strong>{C7_NUM}</NormalFont>}
                { C7_NUMCOT.trim() && <><br/><NormalFont tooltipText={"Abrir Mapa de Cotação"} onClick={()=> handleAbrirMapa(EMPRESA, C7_FILIAL, C7_NUMCOT, DisparaBootBox, FechaBootBox) }><strong>Cotação: </strong>{C7_NUMCOT}</NormalFont></> }
                { C7_NUMSC.trim() && C7_TIPO == '1' && <><br/><NormalFont tooltipText={"Abrir Solicitação de Compra"} onClick={()=> handleAbrirSC(EMPRESA, C7_FILIAL, C7_NUMSC, DisparaBootBox, FechaBootBox)}><strong>SC: </strong>{C7_NUMSC}</NormalFont></> }
                { C7_NUMSC.trim() && C7_TIPO == '2' && <><br/><NormalFont tooltipText={"Contrato de Parceria"}><strong>CP: </strong>{C7_NUMSC}</NormalFont></> }
            </> )
}

function handleFornecedorPCColumn(item){
    const { C7_CONTRA, C7_LOJA, A2_NOME, EMAIL, USR_NOME } = item.row.original;

    return ( <CelBreak>
                <NormalFont tooltipText={`Email: ${EMAIL}`} style={{ padding: '1vh 0' }}><strong>{item.value.trim()}/{C7_LOJA}</strong> - {A2_NOME.trim()} </NormalFont>
                { USR_NOME && USR_NOME.trim() && <><br/><strong>Solicitante: </strong>{USR_NOME} </> }
                { C7_CONTRA.trim() && <><br/><strong>Contrato: </strong>{C7_CONTRA} </> }
            </CelBreak> )
}

const handleItensPendentes = async(Empresa, Filial, Numero, Fornecedor, Loja, DisparaBootBox, FechaBootBox) => {
    let columnsItensPendente = [
        { Header: 'PC',                 accessor: "C7_NUM",         Cell: handleNumeroItemPCColumn},
        { Header: 'Produto/Serviço',    accessor: "C7_PRODUTO",     Cell: handleProdutoPCColumn },
        { Header: 'Prioridade',         accessor: "C7_XFLUXSC",     Cell: handlePrioridadeSCColumn },
        { Header: 'Qtde',               accessor: 'C7_QUANT',       Cell: (item) => formatarComoDecimal(item.value)},
        { Header: 'Total',              accessor: 'C7_TOTAL',       Cell: handleValorTotal },
        { Header: 'Saldo',              accessor: 'SALDO',          Cell: (item) => { 
            const { C7_TOTAL, C7_VLDESC, C7_QUANT, C7_QUJE, C7_QTDACLA, C7_QUJB, C7_VALFRE } = item.row.original
            const qtde = parseFloat(C7_QUANT) - parseFloat(C7_QUJE) - parseFloat(C7_QTDACLA) - parseFloat(C7_QUJB)
            const saldo = ( parseFloat(C7_TOTAL) - parseFloat(C7_VLDESC) / parseFloat(C7_QUANT) * ( qtde ) ) + parseFloat(C7_VALFRE)

            return formatarComoMoeda(saldo, 2)
        } },
        { Header: 'Emissão',            accessor: 'C7_EMISSAO',     Cell: formatDateColumn },
        { Header: 'Previsão',           accessor: 'C7_DATPRF',      Cell: formatDateColumn },        
    ];

    let consultaDefault = PedidoItens.consulta + 
        " AND C7_FILIAL = FILIAL(SC7) " +
        " AND C7_FORNECE = '" + Fornecedor + "' "+
        " AND C7_LOJA = '" + Loja + "' " + 
        " AND C7_QUANT > (C7_QUJE + C7_QTDACLA + C7_QUJB) " +
        " AND C7_RESIDUO <> 'S' " +
        " AND C7_NUM IN ('" + Numero + "') " +
        " ORDER BY C7_NUM, C7_ITEM "

    let tabelasDefault = PedidoItens.tabelas;

    let retConsulta = await ConsultaTotvs(consultaDefault, tabelasDefault, Empresa + Filial);
    let aDataItensPendente = retConsulta.data;

    const Mensagem = (
        <ResponsiveDataTable columns={columnsItensPendente} data={aDataItensPendente} buttons={[]} habilitaBuscar={false} />
    );

    DisparaBootBox('Itens Pendentes de Lançamentos', Mensagem, [{ variant: 'light', action: FechaBootBox, label: '↩ Voltar' }], {}, null, 'xl');
}

const handleTrackerPedido = async(Empresa, Filial, Numero, Fornecedor, Loja, DisparaBootBox, FechaBootBox) => {
    let columnsTrackerNotaFiscal = [
        { Header: 'Filial',     accessor: 'F1_FILIAL' },
        { Header: 'Tipo Doc.',  accessor: 'TIPO_DOC' },
        { Header: 'Documento',  accessor: 'F1_DOC' },
        { Header: 'Serie',      accessor: 'F1_SERIE' },
        { Header: 'Emissão',    accessor: 'F1_EMISSAO', Cell: formatDateColumn },
        { Header: 'Valor',      accessor: 'TOTAL', Cell: handleValorTotal },
        // { Header: 'Status',     accessor: 'STATUS' } //, Cell: handleStatusNF },
    ];

    let consultaDefault = TrackerNotaFiscal.consulta.replace("FILTRO", ` AND D1_FILIAL = '${Filial}' AND D1_PEDIDO = '${Numero}' AND D1_FORNECE = '${Fornecedor}' AND D1_LOJA = '${Loja}' `);
    let tabelasDefault = TrackerNotaFiscal.tabelas;

    let retConsulta = await ConsultaTotvs(consultaDefault, tabelasDefault, Empresa + Filial);
    let aDataTrackerNotaFiscal = retConsulta.data;

    const Mensagem = (
        <ResponsiveDataTable columns={columnsTrackerNotaFiscal} data={aDataTrackerNotaFiscal} buttons={[]} habilitaBuscar={false} />
    );

    DisparaBootBox('Tracker de Pedido', Mensagem, [{ variant: 'light', action: FechaBootBox, label: '↩ Voltar' }], {}, null, 'xl');
}

function handleSaldoPC (item, DisparaBootBox, FechaBootBox){
    const { EMPRESA, C7_FILIAL, C7_NUM, C7_FORNECE, C7_LOJA, C7_TOTAL, FRETE } = item.row.original;
    
    if (DisparaBootBox && FechaBootBox){
        return (
            <>
                <NormalFont 
                    tooltipText={"Tracker de Lançamentos"} 
                    style={{ padding: '1vh 0' }}
                    onClick={(e)=> handleTrackerPedido(EMPRESA, C7_FILIAL, C7_NUM, C7_FORNECE, C7_LOJA, DisparaBootBox, FechaBootBox)}
                >
                    <strong>Saldo: </strong> {handleValorTotal(item)}
                </NormalFont>
                <br/>
                { item && item.value > 0 && (
                    <NormalFont 
                        tooltipText={"Itens Pendentes de Lançamentos"} 
                        style={{ padding: '1vh 0' }}
                        onClick={(e)=> handleItensPendentes(EMPRESA, C7_FILIAL, C7_NUM, C7_FORNECE, C7_LOJA, DisparaBootBox, FechaBootBox)}
                    >
                        <strong>Total: </strong> {formatarComoMoeda(C7_TOTAL,2)}
                    </NormalFont>
                )}
				{ item && FRETE > 0 && (
					<br/>
				)}
                { item && FRETE > 0 && (
                    <NormalFont 
                        tooltipText={"Frete informado por Pedido"} 
                        style={{ padding: '1vh 0' }}
                    >
                        <strong>Frete Total(PC): </strong> {formatarComoMoeda(FRETE,2)}
                    </NormalFont>
                )}
                { item && item.value === 0 && ( <><strong>Total: </strong> {formatarComoMoeda(C7_TOTAL,2)}</> ) }
            </>
        )
    }else{
        return (
            <>
                <strong>Saldo: </strong> {handleValorTotal(item)}
                <br/><strong>Total: </strong> {formatarComoMoeda(C7_TOTAL,2)}
            </>
        )
    }
}

function handleStatusPC(item){
    const cStatus = handleStatusPCExcel(item)
    const cEmail = handleStatusEnvioPCExcel(item);

    return (
        <>
            <strong>{cStatus}</strong>
            <br/><strong>Envio: </strong> {cEmail}
        </>
    )
}

function handleStatusEnvioPCExcel(item){
    const { C7_XENVTET } = item.row.original;
    let cEmail = ''
    //Retorno Envio
    switch (C7_XENVTET.trim()){
        case "":
            cEmail = 'Não Enviado'
            break
        case "E":
            cEmail = 'Enviado'
            break
        case "R":
            cEmail = 'Lido'
            break
        case "N":
            cEmail = 'Não Enviar'
            break
        default:
            cEmail = 'Não Enviado'
            break
    }

    return cEmail
}

function handleStatusPCExcel(item){
    const {
        C7_CONAPRO,
        C7_RESIDUO,
        C7_QUANT,
        C7_QUJE,
        C7_QUJB,
        C7_QTDACLA,        
    } = item.row.original;

    // Aplica trim nos campos e converte para número onde necessário
    const quje = Number(C7_QUJE.trim());
    const quant = Number(C7_QUANT.trim());
    const qujb = Number(C7_QUJB.trim());
    const qacl = Number(C7_QTDACLA.trim());
    const aprov = C7_CONAPRO.trim();
    const residuo = C7_RESIDUO.trim();
    let cStatus = ''

    cStatus = 'Indeterminado'; // Caso nenhuma regra seja atendida

    if (aprov === 'B' && residuo === '') {
        cStatus = 'Em Aprovação'; //Habilitar "Botão para Fila de Aprovadores"
    }
    else if (aprov === 'R' && residuo === '') {
        cStatus = 'Rejeitado'; //Habilitar "Botão para Fila de Aprovadores"
    }
    // else if (quje === 0 && qacl === 0 && tipo !== 1 && residuo === '' ) {
    //     cStatus = 'Pendente (Pedido de AE)'; //Botão para Imprimir PDF
    // }
    // else if (quje === 0 && qacl === 0 && contrato !== '' && residuo === '' ) {
    //     cStatus = 'Pendente (Pedido GCT)'; //Botão para Imprimir PDF
    // }
    else if (quje === 0 && qacl === 0 && residuo === '' ) {
        cStatus = 'Pendente'
    }
    else if (qacl > 0 && quje + qujb + qacl <= quant ) {
        cStatus = 'Em Recebimento'; //Habilitar "Botão para Rastreio"
    }    
    else if (quje > 0 && quje + qujb < quant ) {
        cStatus = 'Recebido Parcialmente'; //Habilitar "Botão para Rastreio"
    }
    else if (quje > 0 && quje + qujb === quant ) {
        cStatus = 'Recebido'; //Habilitar "Botão para Rastreio"
    }
    // else if (contrato !== '' && residuo !== '') {
    //     cStatus = 'Eliminado Residuo (Pedido GCT)';
    // }
    // else if (tipo === 1 && residuo !== '') {
    //     cStatus = 'Eliminado Residuo (Pedido AE)';
    // }
    else if (residuo !== '') {
        cStatus = 'Eliminado Residuo';
    }

    return cStatus
}

const handleAbrirPDF = async (numeroPedido, empresa, filial) => {
    const blob = await PedidoCompraPDF( numeroPedido, empresa, filial)
    const url = URL.createObjectURL(blob);
    window.open(url);
};

function handleUMedidaQtd(item){
    const quantidade = formatarComoDecimal(parseLocaleNumber(item.quantidade), 4)

    return ( <p class="d-flex justify-content-between">
                <span>
                    <strong>U.M.: </strong> {item.unidadeMedida}
                </span>
                <span>
                    <strong>Qtde.: </strong> {quantidade}
                </span>
            </p> )
}

function handleQtd(item){
    return ( <p>
                <strong>Qtde.: </strong> {item.quantidade}
            </p> )
}

function handleValorUnitarioCard(item){
    return ( <p>
                <strong>Valor Unitário: </strong> {formatarComoMoeda(parseLocaleNumber(item.valorUnitario),4)}
            </p> )
}

function handleValorUnitario(item){
    return ( <p>
                <strong>Valor Unitário: </strong> {formatarComoMoeda(item.valorUnitario,4)}
            </p> )
}

function handleValorTotalPCCard(item){
    return ( 
        <>
            <p>
                <strong>Desconto: </strong> {formatarComoMoeda(item.desconto,2)}
            </p> 
            <p>
                <strong>Valor Total: </strong> {formatarComoMoeda(parseLocaleNumber(item.valorTotal) - item.desconto,2)}
            </p> 
        </>
    )
}

function handleValorTotalPC(item){
    return ( 
        <>
            <p>
                <strong>Valor Total: </strong> {formatarComoMoeda(item.valorTotal - item.desconto,2)}
            </p> 
        </>
    )
}

function handleSolicCompra(item){
    const itemRender = (
        <p>
            <strong>Solic. Compra: </strong> {item.solicitacao+ ' / ' + item.itemSolicitacao }
        </p> )
    
    return ( item.solicitacao && itemRender ) || ''
}

function handleCentroCustoLabel(item){
    return (
        <>
            <br/>
            { item.campoCentroCusto?.value?.trim() && (
				<p>
					<strong>Centro de Custo: </strong> {item.value}
				</p> 
			)}
            { item.certificado.trim() && (
                <p>
                    <strong>C. A.: </strong> {item.certificado}
                </p> 
            )}
        </>
    )
}

export { handleCentroCustoLabel, handleCCPCColumn, handleNumeroItemPCColumn, handleProdutoPCColumn, handleSaldoPCColumn, handleQtdValorPCColumn, handleFilaAprovadores, handleUMedidaQtd, handleSolicCompra, handleNumeroPCColumn, handleFornecedorPCColumn, handleStatusPC, handleSaldoPC, handleQtd, handleValorUnitario, handleValorUnitarioCard, handleValorTotalPCCard, handleValorTotalPC, handleAbrirMapa, handleAbrirSC, handleStatusEnvioPCExcel, handleStatusPCExcel, handleSaldoPrecoPC }